import React from 'react';
import ZoomOutMap from '@material-ui/icons/ZoomOutMap';

import { base64ToPng } from '../../shared/images';

import { Container, Content, ImageContainer, Image, Temperature, Name, Date, HoverEffect } from './styles';

export default function ({
  name,
  width,
  color,
  onClick,
  ItemWithHighestTemp,
}) {
  return (
    <Container width={width} >
      <Content>
        <ImageContainer>
          <Image color={color} onClick={onClick} image={base64ToPng(ItemWithHighestTemp.image)}>
            <HoverEffect>
              <ZoomOutMap style={{ margin: 'auto', color: 'white' }} />
            </HoverEffect>
          </Image>
          <Temperature color={color}>
            {ItemWithHighestTemp.temperature}°C
          </Temperature>
        </ImageContainer>
        <Name>{name}</Name>
        <Date color="textSecondary">{ItemWithHighestTemp.date}</Date>
      </Content>
    </Container>
  );
}
